<template>
  <base-card>
    <base-question text="Informe o tipo de categoria:" />

    <div class="categories">
      <div class="category-box" @click="selectCategory('pizza')">
        <i class="fal fa-pizza-slice"></i>
        <span>Pizza</span>
      </div>
      <div class="category-box" @click="selectCategory('drink')">
        <i class="fal fa-wine-glass-alt"></i>
        <span>Bebidas</span>
      </div>
      <div class="category-box" @click="selectCategory('step')">
        <i class="fal fa-soup"></i>
        <span>Outros</span>
      </div>
    </div>
  </base-card>
</template>

<script>
// components
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";

export default {
  components: {
    BaseCard,
    BaseQuestion
  },
  data() {
    return {
      
    }
  },
  props: {
    targetItem: { default: {} }
  },
  methods: {
    selectCategory(mode) {
      const availableModes = ["pizza", "drink", "step"];

      if (availableModes.includes(mode) && !this.targetItem._id) {
        this.targetItem.mode = mode;
        this.$emit('onSelect');
      }
    },
  },
};
</script>

<style scoped>
.categories {
  display: flex;
  flex-wrap: wrap;
}
.category-box {
  flex: 1;
  max-width: 50%;
  min-width: calc(50% - 15px);
  height: 95px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background-color: var(--box-up);
  color: var(--label-primary);
  cursor: pointer;
  transition: color linear 0.15s;
}
.category-box:first-child {
  margin-right: 15px;
}
.category-box:last-child {
  margin-top: 15px;
  max-width: calc(50% - 7.5px);
}
.category-box i {
  font-size: 20px;
  margin-bottom: 10px;
}
.category-box:hover {
  color: var(--default);
}
</style>